const getIdFromSlug = slug =>
  slug
    .split('-')
    .pop()
    .trim()

export default getIdFromSlug
